<template>
  <div
      class="d-flex"
      :style="`width: ${width}; height: ${height}; ${styles}`"
      :class="getClasses"
      :title="title"
      @click="$emit('onClick')"
      @blur="$emit('onBlur')"
      @focus="$emit('onFocus')"
      tabindex="1"
  >
    <slot></slot>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "ks-flex",
  mixins: [checkPermissions],
  props: {
    direction: {
      type: String,
      default: 'row', // row, column
      validator: function (value) {
        return [
          'row',
          'column'
        ].indexOf(value) !== -1
      }
    },
    justify: {
      type: String,
      default: 'start', // start, end, center, between, around
      validator: function (value) {
        return [
          'start',
          'end',
          'center',
          'between',
          'around'
        ].indexOf(value) !== -1
      }
    },
    align: {
      type: String,
      default: 'center', // start, end, center, between, around
      validator: function (value) {
        return [
          'start',
          'end',
          'center',
          'between',
          'around'
        ].indexOf(value) !== -1
      }
    },
    alignContent: {
      type: String,
      default: null, // start, end, center, between, around, stretch
      validator: function (value) {
        return [
          'start',
          'end',
          'center',
          'between',
          'around',
          'stretch'
        ].indexOf(value) !== -1
      }
    },
    wrap: {
      type: String,
      default: 'wrap', // wrap, nowrap, wrap-reverse
      validator: function (value) {
        return [
          'wrap',
          'nowrap',
          'wrap-reverse'
        ].indexOf(value) !== -1
      }
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    styles: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: null
    },
  },
  computed: {
    getClasses() {
      let returnClasses = "";
      if (this.direction) {
        returnClasses += ` flex-${this.direction}`;
      }
      if (this.justify) {
        returnClasses += ` justify-content-${this.justify}`;
      }
      if (this.align) {
        returnClasses += ` align-items-${this.align}`;
      }
      if (this.alignContent) {
        returnClasses += ` align-content-${this.alignContent}`;
      }
      if (this.wrap) {
        returnClasses += ` flex-${this.wrap}`;
      }
      return returnClasses + ' ' + this.classes;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    }
  }
}
</script>
